(function (root, factory) {
    if (typeof window.define === 'function' && window.define.amd) {
        // AMD. Register as an anonymous module.
        window.define(['exports', 'echarts'], factory)
    } else if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
        // CommonJS
        factory(exports, require('echarts'))
    } else {
        // Browser globals
        factory({}, root.echarts)
    }
}(this, function (exports, echarts) {
    var log = function (msg) {
        if (typeof console !== 'undefined') {
            console && console.error && console.error(msg)
        }
    }
    if (!echarts) {
        log('ECharts is not Loaded')
        return
    }
    echarts.registerTheme('Aaron', {
        'color': [
            '#0291ff',
            '#7ed221',
            '#ffa715',
            '#44d1fd',
            '#ff5400'
        ],
        'backgroundColor': 'rgba(252,252,252,0)',
        'textStyle': {},
        'title': {
            'textStyle': {
                'color': '#17233d'
            },
            'subtextStyle': {
                'color': '#515a6e'
            }
        },
        'line': {
            'itemStyle': {
                'borderWidth': '2'
            },
            'lineStyle': {
                'width': '3'
            },
            'symbolSize': '8',
            'symbol': 'emptyCircle',
            'smooth': false
        },
        'radar': {
            'itemStyle': {
                'borderWidth': '2'
            },
            'lineStyle': {
                'width': '3'
            },
            'symbolSize': '8',
            'symbol': 'emptyCircle',
            'smooth': false
        },
        'bar': {
            'itemStyle': {
                'barBorderWidth': 0,
                'barBorderColor': '#EBEEF5'
            }
        },
        'pie': {
            'itemStyle': {
                'borderWidth': 0,
                'borderColor': '#EBEEF5'
            }
        },
        'scatter': {
            'itemStyle': {
                'borderWidth': 0,
                'borderColor': '#EBEEF5'
            }
        },
        'boxplot': {
            'itemStyle': {
                'borderWidth': 0,
                'borderColor': '#EBEEF5'
            }
        },
        'parallel': {
            'itemStyle': {
                'borderWidth': 0,
                'borderColor': '#EBEEF5'
            }
        },
        'sankey': {
            'itemStyle': {
                'borderWidth': 0,
                'borderColor': '#EBEEF5'
            }
        },
        'funnel': {
            'itemStyle': {
                'borderWidth': 0,
                'borderColor': '#EBEEF5'
            }
        },
        'gauge': {
            'itemStyle': {
                'borderWidth': 0,
                'borderColor': '#EBEEF5'
            }
        },
        'candlestick': {
            'itemStyle': {
                'color': '#e6a0d2',
                'color0': 'transparent',
                'borderColor': '#e6a0d2',
                'borderColor0': '#3fb1e3',
                'borderWidth': '2'
            }
        },
        'graph': {
            'itemStyle': {
                'borderWidth': 0,
                'borderColor': '#EBEEF5'
            },
            'lineStyle': {
                'width': '1',
                'color': '#c5c8ce'
            },
            'symbolSize': '8',
            'symbol': 'emptyCircle',
            'smooth': false,
            'color': [
                '#2d8cf0',
                '#19be6b',
                '#2db7f5',
                '#ff9900',
                '#ed4014'
            ],
            'label': {
                'color': '#ffffff'
            }
        },
        'map': {
            'itemStyle': {
                'normal': {
                    'areaColor': '#eeeeee',
                    'borderColor': '#aaaaaa',
                    'borderWidth': 0.5
                },
                'emphasis': {
                    'areaColor': 'rgba(63,177,227,0.25)',
                    'borderColor': '#3fb1e3',
                    'borderWidth': 1
                }
            },
            'label': {
                'normal': {
                    'textStyle': {
                        'color': '#ffffff'
                    }
                },
                'emphasis': {
                    'textStyle': {
                        'color': '#3fb1e3'
                    }
                }
            }
        },
        'geo': {
            'itemStyle': {
                'normal': {
                    'areaColor': '#eeeeee',
                    'borderColor': '#aaaaaa',
                    'borderWidth': 0.5
                },
                'emphasis': {
                    'areaColor': 'rgba(63,177,227,0.25)',
                    'borderColor': '#3fb1e3',
                    'borderWidth': 1
                }
            },
            'label': {
                'normal': {
                    'textStyle': {
                        'color': '#ffffff'
                    }
                },
                'emphasis': {
                    'textStyle': {
                        'color': '#3fb1e3'
                    }
                }
            }
        },
        'categoryAxis': {
            'axisLine': {
                'show': true,
                'lineStyle': {
                    'color': '#ebeef5'
                }
            },
            'axisTick': {
                'show': false,
                'lineStyle': {
                    'color': '#333'
                }
            },
            'axisLabel': {
                'show': true,
                'textStyle': {
                    'color': '#515a6e'
                }
            },
            'splitLine': {
                'show': true,
                'lineStyle': {
                    'color': [
                        '#ebeef5'
                    ]
                }
            },
            'splitArea': {
                'show': false,
                'areaStyle': {
                    'color': [
                        'rgba(250,250,250,0.05)',
                        'rgba(200,200,200,0.02)'
                    ]
                }
            }
        },
        'valueAxis': {
            'axisLine': {
                'show': true,
                'lineStyle': {
                    'color': '#ebeef5'
                }
            },
            'axisTick': {
                'show': false,
                'lineStyle': {
                    'color': '#333'
                }
            },
            'axisLabel': {
                'show': true,
                'textStyle': {
                    'color': '#515a6e'
                }
            },
            'splitLine': {
                'show': true,
                'lineStyle': {
                    'color': [
                        '#ebeef5'
                    ]
                }
            },
            'splitArea': {
                'show': false,
                'areaStyle': {
                    'color': [
                        'rgba(250,250,250,0.05)',
                        'rgba(200,200,200,0.02)'
                    ]
                }
            }
        },
        'logAxis': {
            'axisLine': {
                'show': true,
                'lineStyle': {
                    'color': '#ebeef5'
                }
            },
            'axisTick': {
                'show': false,
                'lineStyle': {
                    'color': '#333'
                }
            },
            'axisLabel': {
                'show': true,
                'textStyle': {
                    'color': '#515a6e'
                }
            },
            'splitLine': {
                'show': true,
                'lineStyle': {
                    'color': [
                        '#ebeef5'
                    ]
                }
            },
            'splitArea': {
                'show': false,
                'areaStyle': {
                    'color': [
                        'rgba(250,250,250,0.05)',
                        'rgba(200,200,200,0.02)'
                    ]
                }
            }
        },
        'timeAxis': {
            'axisLine': {
                'show': true,
                'lineStyle': {
                    'color': '#ebeef5'
                }
            },
            'axisTick': {
                'show': false,
                'lineStyle': {
                    'color': '#333'
                }
            },
            'axisLabel': {
                'show': true,
                'textStyle': {
                    'color': '#515a6e'
                }
            },
            'splitLine': {
                'show': true,
                'lineStyle': {
                    'color': [
                        '#ebeef5'
                    ]
                }
            },
            'splitArea': {
                'show': false,
                'areaStyle': {
                    'color': [
                        'rgba(250,250,250,0.05)',
                        'rgba(200,200,200,0.02)'
                    ]
                }
            }
        },
        'toolbox': {
            'iconStyle': {
                'normal': {
                    'borderColor': '#c5c8ce'
                },
                'emphasis': {
                    'borderColor': '#515a6e'
                }
            }
        },
        'legend': {
            'textStyle': {
                'color': '#515a6e'
            }
        },
        'tooltip': {
            'axisPointer': {
                'lineStyle': {
                    'color': '#ebeef5',
                    'width': 1
                },
                'crossStyle': {
                    'color': '#ebeef5',
                    'width': 1
                }
            }
        },
        'timeline': {
            'lineStyle': {
                'color': '#ebeef5',
                'width': 1
            },
            'itemStyle': {
                'normal': {
                    'color': '#ebeef5',
                    'borderWidth': 1
                },
                'emphasis': {
                    'color': '#515a6e'
                }
            },
            'controlStyle': {
                'normal': {
                    'color': '#ebeef5',
                    'borderColor': '#ebeef5',
                    'borderWidth': 0.5
                },
                'emphasis': {
                    'color': '#ebeef5',
                    'borderColor': '#ebeef5',
                    'borderWidth': 0.5
                }
            },
            'checkpointStyle': {
                'color': '#2d8cf0',
                'borderColor': '#2d8cf0'
            },
            'label': {
                'normal': {
                    'textStyle': {
                        'color': '#c5c8ce'
                    }
                },
                'emphasis': {
                    'textStyle': {
                        'color': '#c5c8ce'
                    }
                }
            }
        },
        'visualMap': {
            'color': [
                '#2a99c9',
                '#afe8ff'
            ]
        },
        'dataZoom': {
            'backgroundColor': 'rgba(255,255,255,0)',
            'dataBackgroundColor': 'rgba(222,222,222,1)',
            'fillerColor': 'rgba(255, 255, 255, 0.6)',
            'handleColor': '#c5c8ce',
            'handleSize': '100%',
            'textStyle': {
                'color': '#17233D'
            }
        },
        'markPoint': {
            'label': {
                'color': '#ffffff'
            },
            'emphasis': {
                'label': {
                    'color': '#ffffff'
                }
            }
        }
    })
}))
